import { BaseService } from "../../Base/BaseService";

export interface IFavoritePost {
  favoriteId: number;
  id: number;
  masterId: number;
  serviceId: number;
  title: string;
  description: string;
  imageUrl: string;
  masterName: string;
  createdAt: string;
}

export interface IFavoritePostsResponse {
  posts: IFavoritePost[];
  nextCursor: number | null;
  hasMore: boolean;
}

export interface IFavoritePostActionResponse {
  success: boolean;
}

export class FavoritePostsService extends BaseService {
  public static async GetFavorites(limit: number = 20, cursor?: number | null): Promise<IFavoritePostsResponse> {
    let url = this.BaseApiUrl + `/posts/favorites?limit=${limit}`;

    if (cursor) {
      url += `&cursor=${cursor}`;
    }

    return await BaseService.get<IFavoritePostsResponse>(url);
  }

  public static async Add(postId: number): Promise<IFavoritePostActionResponse> {
    return await BaseService.post<IFavoritePostActionResponse>(this.BaseApiUrl + `/posts/${postId}/favorite`, {});
  }

  public static async Remove(postId: number): Promise<IFavoritePostActionResponse> {
    return await BaseService.delete<IFavoritePostActionResponse>(this.BaseApiUrl + `/posts/${postId}/favorite`);
  }
}
